import Box from "@mui/material/Box";
import { alpha } from "@mui/material/styles";

import i18n from "@plannel/utils/i18n";
import { FS } from "@plannel/utils/font-util";

/*
 * Import History · Transform History 가 함께 쓰는 그리드 조각(상태 칩, 소요 시간).
 * 두 화면의 이력 그리드가 같은 모양으로 보이게 하는 단일 소스다.
 */

// 의미 → [글자, 배경 기준색, 점]. 중단은 의미색이 아니라 회색으로 가라앉힌다.
const TONES = {
  success: ["success.dark", "success", "success.main"],
  warning: ["warning.dark", "warning", "warning.main"],
  error: ["error.dark", "error", "error.main"],
  neutral: ["text.secondary", "grey", "grey.500"],
};

/* label 은 i18n 키. 그리드 셀에 굳지 않도록 그릴 때마다 i18n 싱글턴으로 번역한다. */
export const StatusChip = ({ label, tone }) => {
  const [textColor, base, dotColor] = TONES[tone] ?? TONES.neutral;
  return (
    <Box component="span" sx={{
      display: "inline-flex", alignItems: "center", gap: 0.6, px: 1, lineHeight: "18px", borderRadius: 2.5,
      fontSize: FS.CAPTION, fontWeight: 500, color: textColor,
      bgcolor: theme => alpha(base === "grey" ? theme.palette.grey[500] : theme.palette[base].main, 0.12),
      "&::before": { content: '""', width: 6, height: 6, borderRadius: "50%", bgcolor: dotColor },
    }}>
      {i18n.t(label)}
    </Box>
  );
};

/* 초 단위. 서버가 같은 시계로 찍은 두 시각의 차이라 타임존 영향이 없다. */
export const secondsBetween = (start, end) => {
  if (!start || !end) {
    return null;
  }
  const seconds = Math.round((new ZDate(end) - new ZDate(start)) / 1000);
  return Number.isFinite(seconds) && seconds >= 0 ? seconds : null;
};

// h:mm:ss — 언어와 무관한 표기라 번역이 필요 없다.
export const formatDuration = ({ value }) => {
  if (value === null || value === undefined) {
    return "";
  }
  const h = Math.floor(value / 3600);
  const m = Math.floor((value % 3600) / 60);
  const s = value % 60;
  const pad = n => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
};
